import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {HorariosTiendaComponent, TiendaEditComponent, TiendasCrudComponent} from './components/tiendas.crud.component';
import {
  UsuarioEditComponent,
  UsuarioNewComponent,
  UsuariosCrudComponent
} from './components/usuarios.crud.component';
import {RolCrudComponent, RolEditComponent, RolNewComponent} from './components/roles.crud.component';
import {BusquedaEmpleadoComponent} from './components/busqueda.empleado.component';
import {AdminSecurityServices} from './services/admin.security.services';
import {CargosCrudComponent, CargosEditComponent, CargosNewComponent} from './components/cargos.crud.component';
import {EditGrupoCargoComponent, GrupoCargosCrudComponent, NewGrupoCargoComponent} from './components/grupo.cargos.crud.component';
import {LogComponent} from './components/log.component';


const adminRoutes: Routes = [
  {path: 'admin/tiendas', component: TiendasCrudComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/tiendas/horarios', component: HorariosTiendaComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/tiendas/edit/:id', component: TiendaEditComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/usuarios', component: UsuariosCrudComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/usuarios/edit/:id', component: UsuarioEditComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/usuarios/new', component: UsuarioNewComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/roles', component: RolCrudComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/roles/edit/:id', component: RolEditComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/roles/new', component: RolNewComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/cargos', component: CargosCrudComponent},
  {path: 'admin/cargos/edit/:id', component: CargosEditComponent},
  {path: 'admin/cargos/new', component: CargosNewComponent},
  {path: 'admin/grupocargos', component: GrupoCargosCrudComponent},
  {path: 'admin/grupocargos/edit/:id', component: EditGrupoCargoComponent},
  {path: 'admin/grupocargos/new', component: NewGrupoCargoComponent},
  {path: 'admin/busquedaEmpleado', component: BusquedaEmpleadoComponent, canActivate: [AdminSecurityServices]},
  {path: 'admin/log', component: LogComponent}

];

@NgModule({
  imports: [RouterModule.forChild(adminRoutes)],
  exports: [RouterModule]
})
export class AdminRouterModule {

}
